
import React from 'react';
import { Twitter, Linkedin, Instagram } from 'lucide-react';
import { Company } from '@/lib/types';

interface CompanyBioProps {
  company: Company | null;
  companyName: string;
}

const CompanyBio: React.FC<CompanyBioProps> = ({ company, companyName }) => {
  if (!company) return null;
  
  return (
    <div className="text-redflags-gray mb-6 max-w-3xl">
      {company.website && (
        <a
          href={company.website.startsWith('http') ? company.website : `https://${company.website}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-redflags-red hover:text-redflags-dark transition-colors block mb-3"
        >
          Visit company website
        </a>
      )}
      
      {/* Social Media Links - moved here from CompanyLinks */}
      <div className="flex gap-3 mb-4">
        {company.twitterUrl && (
          <a
            href={company.twitterUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-redflags-gray hover:text-redflags-red transition-colors"
            aria-label={`${companyName} Twitter`}
          >
            <Twitter className="h-5 w-5" />
          </a>
        )}
        
        {company.linkedinUrl && (
          <a
            href={company.linkedinUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-redflags-gray hover:text-redflags-red transition-colors"
            aria-label={`${companyName} LinkedIn`}
          >
            <Linkedin className="h-5 w-5" />
          </a>
        )}
        
        {company.instagramUrl && (
          <a
            href={company.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-redflags-gray hover:text-redflags-red transition-colors"
            aria-label={`${companyName} Instagram`}
          >
            <Instagram className="h-5 w-5" />
          </a>
        )}
      </div>
      
      <h2 className="font-medium text-redflags-dark mb-1">About the company</h2>
      <p>{company.bio || `No bio available for ${companyName}`}</p>
    </div>
  );
};

export default CompanyBio;
